/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_FInputs */

const en_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program F`)
};

const fr_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme F`)
};

const de_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programm F`)
};

const it_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma F`)
};

const ru_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программа F`)
};

const es_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa F`)
};

const zh_cn2_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序 F`)
};

const ja_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムF`)
};

const hi_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम एफ`)
};

const pt_pt2_subtitle_export_program_f = /** @type {(inputs: Subtitle_Export_Program_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa F`)
};

/**
* | output |
* | --- |
* | "Program F" |
*
* @param {Subtitle_Export_Program_FInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_f = /** @type {((inputs?: Subtitle_Export_Program_FInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_FInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_f(inputs)
	if (locale === "de") return de_subtitle_export_program_f(inputs)
	if (locale === "it") return it_subtitle_export_program_f(inputs)
	if (locale === "ru") return ru_subtitle_export_program_f(inputs)
	if (locale === "es") return es_subtitle_export_program_f(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_f(inputs)
	if (locale === "ja") return ja_subtitle_export_program_f(inputs)
	if (locale === "hi") return hi_subtitle_export_program_f(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_f(inputs)
	return en_subtitle_export_program_f(inputs)
});